export default __webpack_public_path__ + "img/85ad37703b2a61ba94f8b941ff1d4b91.svg";